// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimQuestion from '@deere/cps-it.warranty-model-factory/lib/claim-question';

const ClaimQuestionDropdown = props =>
    <select
        {...props}
    >
        <option value=''/>
        {
            props.list.map((option, index) =>
                <option
                    key={index}
                    value={option.key}
                >
                    {option.value}
                </option>
            )
        }
    </select>;

ClaimQuestionDropdown.displayName = 'ClaimQuestionDropdown';
ClaimQuestionDropdown.propTypes = {
    list: PropTypes.arrayOf(PropTypes.instanceOf(ClaimQuestion)).isRequired,
    value: PropTypes.string.isRequired
};

export default ClaimQuestionDropdown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/claim-question-dropdown.js